import React, { useState, useEffect } from 'react'
import Classes from './Team.module.css'
import RecordTable from './RecordTable/RecordTable'

export default function Team() {

    return (
        <RecordTable />
    )
}
